import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { Loader } from "../_components";
import EmbeddedSectionView from "../_components/embedded-section-view.component";
import { EmbeddedSectionService } from "../_service/embedded-section.service";

export const EMBEDDED_SECTION_PAGE_ROUTE = "/embedded-section/:slug";

export function getEmbeddedSectionDetailPageRoute(slug) {
  return `/embedded-section/${slug}`;
}

function EmbeddedSectionDetailPageComponent({
  user,
  community,
  addToast = (title, description) => {},
}) {
  const { slug } = useParams();

  const [embeddedSection, setEmbeddedSection] = useState(null);
  const [isLoadingCompleted, setIsLoadingCompleted] = useState(false);

  useEffect(() => {
    if (community) {
      // load details for the embedded section
      EmbeddedSectionService.getEmbeddedSectionDetailBySlug(community, slug)
        .then(({ embeddedSection }) => {
          console.log({ embeddedSection });
          setEmbeddedSection(embeddedSection);
        })
        .catch((error) => {
          addToast(
            "Something went wrong loading the section",
            "",
            ToastTypes.danger
          );
        })
        .finally(() => {
          setIsLoadingCompleted(true);
        });
    }
  }, [community, slug]);

  if (!user) {
    return (
      <div className="EmbeddedSectionDetailPage">
        Please login to view this area.
      </div>
    );
  }

  return (
    <div className="EmbeddedSectionDetailPage">
      {isLoadingCompleted ? (
        embeddedSection ? (
          <EmbeddedSectionView embeddedSection={embeddedSection} />
        ) : (
          <div className="text-red-500">Something went wrong!</div>
        )
      ) : (
        <Loader />
      )}
    </div>
  );
}

const EmbeddedSectionDetailPage = withToast(
  connect((s) => ({
    user: s.auth,
    community: s.community,
  }))(EmbeddedSectionDetailPageComponent)
);

export default EmbeddedSectionDetailPage;
